import React, { useEffect } from 'react';
import { copiarPlantillaReceta } from './utils/fileUtils';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CitaProvider } from './context/CitaContext';
import AdminLayout from './layouts/AdminLayout';

// Import custom styles
import './styles/animations.css';


// Páginas de autenticación
import Login from './pages/auth/Login';
import Unauthorized from './pages/auth/Unauthorized';

// Importar componentes existentes (ajustar según tu estructura actual)
import Home from './pages/Home';
import AgendarCita from './pages/AgendarCita';
import ConfirmacionCita from './pages/ConfirmacionCita';
import Pago from './pages/Pago';
import Servicios from './pages/Servicios';

// Importar componentes de admin
import Dashboard from './components/admin/Dashboard';
import CitasList from './components/admin/CitasList';
import CitaDetallePage from './components/admin/CitaDetallePage';
import CitasDoctor from './components/admin/CitasDoctor';
import HistoriaClinicaDetalle from './components/admin/HistoriaClinicaDetalle';
import TestReceta from './pages/admin/TestReceta';
import GenerarRecetaPage from './pages/admin/GenerarRecetaPage';

// Importar o crear componentes adicionales necesarios
import PacientesList from './components/admin/PacientesList';
import Plantillas from './components/admin/Plantillas';
import Configuracion from './components/admin/Configuracion';

import './App.css';

function App() {
  // Intentar copiar la plantilla de receta al directorio público al iniciar la app
  useEffect(() => {
    const inicializarArchivos = async () => {
      try {
        await copiarPlantillaReceta();
        console.log('Inicialización de archivos completada');
      } catch (error) {
        console.error('Error durante la inicialización de archivos:', error);
      }
    };
    
    inicializarArchivos();
  }, []);

  return (
    <AuthProvider>
      <CitaProvider>
        <Router>
          <Routes>
            {/* Rutas públicas */}
            <Route path="/login" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            
            {/* Rutas de agendamiento público (ajustar según tu estructura) */}
            <Route path="/" element={<Servicios />} />
            <Route path="/home" element={<Home />} />
            <Route path="/agendar" element={<AgendarCita />} />
            <Route path="/confirmacion" element={<ConfirmacionCita />} />
            <Route path="/pago" element={<Pago />} />
            
            {/* Rutas protegidas con layout administrativo */}
            <Route path="/dashboard" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="citas" element={<CitasList />} />
              <Route path="citas/:citaId" element={<CitaDetallePage />} />
              <Route path="citas-doctor" element={<CitasDoctor />} />
              <Route path="historia-clinica" element={<Navigate to="/dashboard/pacientes" replace />} />
              <Route path="historia-clinica/:cedula" element={<HistoriaClinicaDetalle />} />
              <Route path="pacientes" element={<PacientesList />} />
              <Route path="plantillas" element={<Plantillas />} />
              <Route path="configuracion" element={<Configuracion />} />
              <Route path="test-receta" element={<TestReceta />} />
              <Route path="generar-receta/:pacienteId?" element={<GenerarRecetaPage />} />
            </Route>
            
            {/* Rutas compatibles con la versión anterior */}
            <Route path="/admin/citas/:citaId" element={<Navigate to={(params) => `/dashboard/citas/${params.citaId}`} replace />} />
            <Route path="/admin/historia-clinica/:cedula" element={<Navigate to={(params) => `/dashboard/historia-clinica/${params.cedula}`} replace />} />
            
            {/* Redirección de rutas viejas al nuevo dashboard */}
            <Route path="/admin" element={<Navigate to="/dashboard" replace />} />
            <Route path="/admin/*" element={<Navigate to="/dashboard" replace />} />
            
            {/* Redirección por defecto */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </CitaProvider>
    </AuthProvider>
  );
}

export default App;